var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99887 3C6.1953 3 4.75111 3.82143 3.69977 4.79911C2.65513 5.76786 1.95646 6.92857 1.62611 7.72545C1.55245 7.90179 1.55245 8.09821 1.62611 8.27455C1.95646 9.07143 2.65513 10.2321 3.69977 11.2009C4.75111 12.1786 6.1953 13 7.99887 13C9.80245 13 11.2466 12.1786 12.298 11.2009C13.3426 10.2299 14.0413 9.07143 14.3739 8.27455C14.4475 8.09821 14.4475 7.90179 14.3739 7.72545C14.0413 6.92857 13.3426 5.76786 12.298 4.79911C11.2466 3.82143 9.80245 3 7.99887 3ZM11.2132 8C11.2132 9.77455 9.77343 11.2143 7.99887 11.2143C6.22432 11.2143 4.78459 9.77455 4.78459 8C4.78459 6.22545 6.22432 4.78571 7.99887 4.78571C9.77343 4.78571 11.2132 6.22545 11.2132 8ZM7.99887 6.57143C7.99887 7.35938 7.35825 8 6.5703 8C6.31361 8 6.07254 7.93304 5.86495 7.8125C5.86048 7.875 5.85602 7.93527 5.85602 8C5.85602 9.18304 6.81584 10.1429 7.99887 10.1429C9.18191 10.1429 10.1417 9.18304 10.1417 8C10.1417 6.81696 9.18191 5.85714 7.99887 5.85714C7.93637 5.85714 7.87388 5.85937 7.81138 5.86607C7.92968 6.07366 7.99887 6.31473 7.99887 6.57143Z",
    fill: "#6D738D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.2df2579ad563ad9669049ef125f67614.svg";
export { ForwardRef as ReactComponent };